class ProductBundleGameTech extends HTMLElement {
  connectedCallback() {
    this.initEvents();
    this.initDefaults();
  }

  initEvents() {
    document.addEventListener('click', (e) => {
      if (e.target.matches('.variant-field-pack input')) {
        this.handleVariantClick(e.target);
      }
    });
  }

  handleVariantClick(inputEl) {
    const clickedValue = inputEl.value.replace(/\s/g, '').toLowerCase();
    const clickedQty = inputEl.getAttribute('qty');
    const clickedInputId = inputEl.id;
    const clickedPrice = inputEl.getAttribute('data-price');

    // Update quantity input
    const qtyInput = document.querySelector('input[name="quantity"]');
    if (qtyInput) qtyInput.value = clickedQty;

    // Update bundle properties for cart
    const convertedValue = inputEl.value.replace(/\s+/g, '-').toLowerCase();
    const bundleProperty = document.getElementById('pack-info-property-bundle');
    if (bundleProperty) bundleProperty.value = convertedValue;

    // Update ATC price
    const associatedLabel = document.querySelector(`label[for="${clickedInputId}"]`);
    if (associatedLabel) {
      const priceSpan = associatedLabel.querySelector('.price-main--price');
      if (priceSpan) {
        const price = priceSpan.textContent.trim() + '.00';
        const currentPriceSpan = document.querySelector('.product__price .price__regular .price-item.price-item--regular');
        if (currentPriceSpan) currentPriceSpan.textContent = price;
      }

      // Match image alt to Swiper slide
      this.matchImageToSwiper(associatedLabel);
    }
  }

  matchImageToSwiper(labelEl) {
    const packImage = labelEl.querySelector('.featured-image-product');
    if (!packImage) return;

    const packAlt = packImage.alt.trim();
    console.log('Clicked image alt:', packAlt);

    const gallerySliderEl = document.querySelector('media-gallery .swiper');
    if (gallerySliderEl && gallerySliderEl.swiper) {
      const swiperInstance = gallerySliderEl.swiper;
      let matchFound = false;

      swiperInstance.slides.forEach((slide, index) => {
        const slideImg = slide.querySelector('img');
        if (slideImg && slideImg.alt.trim() === packAlt) {
          console.log('Matching image alt:', slideImg.alt);
          swiperInstance.slideTo(index);
          matchFound = true;
        }
      });

      if (!matchFound) {
        console.log('No matching slide found for:', packAlt);
      }
    }
  }

  initDefaults() {
    document.addEventListener('DOMContentLoaded', () => {
      // Select Pack 2 after 1 second
      setTimeout(() => {
        const pack2Input = document.querySelector('input#pack-2');
        if (pack2Input) pack2Input.click();
      }, 1000);

      // Initialize bundle property after 1.1 seconds
      setTimeout(() => {
        const firstPackInput = document.querySelector('.custom-pack-options input[type="radio"]:checked');
        if (firstPackInput) {
          const convertedValue = firstPackInput.value.replace(/\s+/g, '-').toLowerCase();
          const bundleProperty = document.getElementById('pack-info-property-bundle');
          if (bundleProperty) bundleProperty.value = convertedValue;
        }
      }, 1100);
    });
  }
}

// Register the custom element
customElements.define('product-bundle-game-tech', ProductBundleGameTech);
